import React from 'react';
import { PropTypes } from 'prop-types';

const MenuItem = ({
  isNavbarExpanded, icon, title, link,
}) => {
  return (
    <li className="flex items-center h-10 w-full">
      <a className="flex items-center px-6 w-full h-full font-normal text-xl hover:font-bold hover:bg-vamos-light-gray hover:no-underline" href={link}>
        {icon}
        <div className={`overflow-hidden transition-all duration-200 ${isNavbarExpanded ? 'max-w-full opacity-100' : 'max-w-0 opacity-0'}`}>
          <h2 className="text-vamos-black text-xl px-2.5 font-inherit whitespace-nowrap">{title}</h2>
        </div>
      </a>
    </li>
  );
};

export default MenuItem;

MenuItem.propTypes = {
  isNavbarExpanded: PropTypes.bool.isRequired,
  icon: PropTypes.object,
  title: PropTypes.string.isRequired,
  link: PropTypes.string.isRequired,
};
